/**
 * zoom-dialog.js
 * Lightweight image zoom modal — VAGUE 2 item 9
 *
 * API publique :
 *   window.EDJZoom.open(url, alt) → ouvre le modal sur l'image fournie
 *   window.EDJZoom.close()        → ferme le modal
 *
 * Le modal est créé paresseusement (à la 1re ouverture) puis réutilisé.
 * Fermeture native via Esc, click backdrop, ou bouton ✕.
 *
 * Dépendances : aucune (pas d'imports ES modules).
 */
(function () {
  'use strict';

  let dialog = null;
  let imgEl = null;

  function ensureDialog() {
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.className = 'edj-zoom-dialog';
    dialog.setAttribute('aria-label', 'Image zoomée');

    const inner = document.createElement('div');
    inner.className = 'edj-zoom-dialog__inner';

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'edj-zoom-dialog__close';
    closeBtn.setAttribute('aria-label', 'Fermer');
    closeBtn.textContent = '✕';
    closeBtn.addEventListener('click', close);

    imgEl = document.createElement('img');
    imgEl.className = 'edj-zoom-dialog__image';
    imgEl.alt = '';

    inner.appendChild(closeBtn);
    inner.appendChild(imgEl);
    dialog.appendChild(inner);

    dialog.addEventListener('click', e => {
      if (e.target === dialog) close();
    });

    document.body.appendChild(dialog);
    return dialog;
  }

  function open(url, alt) {
    if (!url) return;
    const d = ensureDialog();
    if (typeof d.showModal !== 'function') return;
    imgEl.src = url;
    imgEl.alt = alt || '';
    if (!d.open) d.showModal();
  }

  function close() {
    if (dialog && dialog.open) dialog.close();
  }

  window.EDJZoom = { open: open, close: close };
})();
